export default "__VITE_ASSET__kugKk3Z6__"